import { Moment } from "moment-timezone";
import Abatimentos from "./abatimentos";
import Darf from "./darf";
import { ResultadoComuns, ResultadoDaytrade, ResultadoFii } from "./resultado";

export default class Imposto implements IImposto {
  public criadoEm!: Moment;
  public dataBase!: Moment;
  public abatimentos!: Abatimentos;
  public resultado?: ResultadoImposto;
  public darf?: Darf;
  public pontoDePartida?: boolean;
  public recalcular?: boolean;
  constructor(param: IImposto) {
    Object.assign(this, param);
  }

  public toJSON(): IImpostoJson {
    return {
      ...this,
      criadoEm: this.criadoEm.format(),
      dataBase: this.dataBase.format(),
    };
  }
}

export interface IImpostoJson extends Omit<IImposto, "criadoEm" | "dataBase"> {
  criadoEm: string;
  dataBase: string;
}

export interface ResultadoImposto {
  resultadoTotal: number;
  irrf: number;
  operacoesComuns: ResultadoComuns;
  operacoesDaytrade: ResultadoDaytrade;
  operacoesFii: ResultadoFii;
}

interface IImposto {
  criadoEm: Moment;
  dataBase: Moment;
  abatimentos: Abatimentos;
  resultado?: {
    resultadoTotal: number;
    irrf: number;
    operacoesComuns: ResultadoComuns;
    operacoesDaytrade: ResultadoDaytrade;
    operacoesFii: ResultadoFii;
  };
  darf?: Darf;
  pontoDePartida?: boolean;
  recalcular?: boolean;
}
